import React, { useState } from 'react';
import AdminUsersPage from './AdminUsersPage';
import AdminActiveSessionsPage from './AdminActiveSessionsPage';
import AdminSyncWorkerPage from './AdminSyncWorkerPage';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import styles from './AdminPage.module.css';

type AdminTab = 'users' | 'sessions' | 'sync-worker';

interface NavbarProps {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
}

const Navbar: React.FC<NavbarProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.navbar}>
      <button
        className={`${styles.navButton} ${activeTab === 'users' ? styles.navButtonActive : ''}`}
        onClick={() => onTabChange('users')}
      >
        <PeopleOutlineIcon />
        <span>Usuários do Sistema</span>
      </button>
      <button
        className={`${styles.navButton} ${activeTab === 'sessions' ? styles.navButtonActive : ''}`}
        onClick={() => onTabChange('sessions')}
      >
        <DynamicFeedIcon />
        <span>Sessões Ativas</span>
      </button>
      <button
        className={`${styles.navButton} ${activeTab === 'sync-worker' ? styles.navButtonActive : ''}`}
        onClick={() => onTabChange('sync-worker')}
      >
        <SyncAltIcon />
        <span>Sincronizador</span>
      </button>
    </div>
  );
};

const AdminPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>('users');

  return (
    <div className={styles.container}>
      <Navbar activeTab={activeTab} onTabChange={setActiveTab} />
      
      <div className={styles.content}>
        {activeTab === 'users' && <AdminUsersPage />}
        {activeTab === 'sessions' && <AdminActiveSessionsPage />}
        {activeTab === 'sync-worker' && <AdminSyncWorkerPage navbar={null} />}
      </div>
    </div>
  );
};

export default AdminPage;
